import React, { useRef } from "react";
import { MapContainer } from "react-leaflet";
import { TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useMap } from "react-leaflet";
import busstop from "../../Images/busstop.png";
import { useEffect } from "react";
const containerStyle = {
  height: "70vh",
  width: "100%",
};
const getStopIcon = L.icon({
  iconUrl: busstop,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});
const AnimateToMarker = ({ lat, lng }) => {
  const map = useMap();

  useEffect(() => {
    map.flyTo([lat, lng], 16, {
      animate: true,
      duration: 1, // in seconds
    });
  }, [lat, lng, map]);

  return null;
};
function FlyToAndPopup({ position, markerRef }) {
  const map = useMap();

  useEffect(() => {
    if (map && markerRef.current) {
      map.setView(position, 14, { animate: true });
      markerRef.current.openPopup();
    }
  }, [map, position, markerRef]);

  return null;
}
const Stopmap = ({ data }) => {
  const markerRef = useRef();
  return (
    <div>
      <MapContainer
        center={[data.latitude, data.longitude]}
        zoom={14}
        style={containerStyle}
        attributionControl={false}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker
          position={[data.latitude, data.longitude]}
          icon={getStopIcon}
          ref={markerRef}
        >
          <Popup>
            <span className="fw-semibold">{data.name}</span>
          </Popup>
        </Marker>
        <FlyToAndPopup
          position={[data.latitude, data.longitude]}
          markerRef={markerRef}
        />
        <AnimateToMarker lat={data.latitude} lng={data.longitude} />
      </MapContainer>
    </div>
  );
};

export default Stopmap;
